import React, { useState, useEffect, useRef, forwardRef } from "react";
import Footer from "../../../../components/home_page/Footer";
import { useDispatch } from "react-redux";
import { closeModal } from "../../../../redux/actions/action-creator";
import InputField from "../../../../components/Input/InputField";
const fallbackInputFields = [
  ...Array(17).fill({}),
  {
    label: "Delivery Note No",
    name: "delivery_note_no",
    type: "text",
    isRequired: true,
  },
  {
    label: "Dispatch Doc No",
    name: "dispatch_doc_no",
    type: "text",
    isRequired: true,
  },
  {
    label: "Dispatch Through",
    name: "dispatch_through",
    type: "text",
    isRequired: true,
  },
  { label: "Destination", name: "destination", type: "text", isRequired: true },
  {
    label: "Carrier Name/Agent",
    name: "carrier_name_agent",
    type: "text",
    isRequired: true,
  },
  {
    label: "Mobile Number",
    name: "carrier_mobile_no",
    type: "text",
    isRequired: true,
  },
  {
    label: "Bill of Loading/LR/RR No",
    name: "bill_of_loading",
    type: "text",
    isRequired: true,
  },
  {
    label: "Date",
    name: "dispatch_date",
    type: "text",
    isRequired: true,
  },
  {
    label: "Vehical Number",
    name: "vehicle_number",
    type: "text",
    isRequired: true,
  },
];

const DispatchDetails = forwardRef((props, ref_name) => {
  const dispatch = useDispatch();

  const handleModalClose = () => {
    // Check if any dispatch detail fields have data
    const hasDispatchData =
      props.data?.delivery_note_no ||
      props.data?.dispatch_doc_no ||
      props.data?.dispatch_through ||
      props.data?.destination ||
      props.data?.carrier_name_agent ||
      props.data?.carrier_mobile_no ||
      props.data?.carrier_mobile_number ||
      props.data?.agent_mobile_no ||
      props.data?.bill_of_loading ||
      props.data?.dispatch_date ||
      props.data?.vehicle_number ||
      props.data?.vehical_number;

    // Update dispatch_detail/dispatch_details status based on whether data exists
    if (!hasDispatchData) {
      if (props.data?.dispatch_detail === "Available") {
        props.setData((prev) => ({
          ...prev,
          dispatch_detail: "Not Available",
        }));
      }
      if (props.data?.dispatch_details === "Available") {
        props.setData((prev) => ({
          ...prev,
          dispatch_details: "Not Available",
        }));
      }
    }

    dispatch(closeModal("dispatch_detail_modal"));
    if (props.setshow_dispatch_details_modal) {
      props.setshow_dispatch_details_modal(false);
    }

    // Focus on the order_detail element
    const target =
      (ref_name && ref_name.current) ||
      props.ref_name?.current ||
      props.inputRefs?.order_detail?.current;
    if (target && target.focus) {
      setTimeout(() => {
        target.focus();
        if (target.setSelectionRange) {
          target.setSelectionRange(0, target.value?.length || 0);
        }
      }, 50);
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "a") {
        e.preventDefault();
        e.stopPropagation();
        handleModalClose();
        return;
      }

      if (e.key === "Escape") {
        e.preventDefault();
        handleModalClose();
        e.stopPropagation();
      }
    };
    document.addEventListener("keydown", handleKeyDown, true);
    return () => {
      document.removeEventListener("keydown", handleKeyDown, true);
    };
  }, [dispatch, props]);

  return (
    <div className="my-card">
      <div className="cross_button" onClick={() => handleModalClose()}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-x"
          viewBox="0 0 16 16"
        >
          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
        </svg>
      </div>
      <div
        className="container pb-3 border border-dark"
        id="card-period"
        style={{ width: "42%", minHeight: "58vh", background: "#fff" }}
      >
        <div className="row">
          <div className="col border-bottom">
            <b>Dispatch Details</b>
          </div>
        </div>
        <div className="row">
          <div className="col">
            {(props.inputFields || fallbackInputFields)
              .slice(17, 26)
              .map(({ label, name, type, isRequired }, index) => {
                const isBillOfLadingField = name === "bill_of_loading";
                const isDispatchDateField = name === "dispatch_date";
                const isVehicleNumberField = name === "vehicle_number";

                if (isDispatchDateField) return null;

                if (isBillOfLadingField) {
                  return (
                    <div
                      className="row m-0 p-0"
                      style={{ height: "3vh" }}
                      key={index}
                    >
                      <div
                        className="m-0 p-0 text-start"
                        style={{ width: "33%" }}
                      >
                        <label>Bill of Lading/LR/RR No</label>
                      </div>
                      <div className="m-0 p-0" style={{ width: "2%" }}>
                        <label>:</label>
                      </div>
                      <div
                        className="m-0 p-0 text-start"
                        style={{ width: "23%", position: "relative" }}
                      >
                        <input
                          style={{
                            textAlign: "left",
                            fontSize: 13,
                            fontWeight: "bold",
                            width: "100%",
                          }}
                          type={type}
                          autoComplete="new-password"
                          name="bill_of_loading"
                          id="bill_of_loading"
                          value={props.data?.bill_of_loading || ""}
                          onChange={props.handleChange}
                          onBlur={props.handleBlur}
                          onFocus={props.handleFocus}
                          onKeyDown={props.handleKeyDown}
                          ref={props.inputRefs.bill_of_loading}
                        />
                      </div>

                      <div
                        className="m-0 p-0 text-start"
                        style={{
                          width: "20%",
                          paddingLeft: 0,
                          textAlign: "right",
                          paddingRight: 4,
                        }}
                      >
                        <label>Date:</label>
                      </div>
                      <div
                        className="m-0 p-0 text-start"
                        style={{ width: "22%", position: "relative" }}
                      >
                        <input
                          style={{
                            textAlign: "left",
                            fontSize: 13,
                            fontWeight: "bold",
                            width: "100%",
                          }}
                          type="text"
                          autoComplete="new-password"
                          name="dispatch_date"
                          id="dispatch_date"
                          value={props.data?.dispatch_date || ""}
                          onChange={props.handleChange}
                          onBlur={props.handleBlur}
                          onFocus={props.handleFocus}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              e.stopPropagation();
                              const nextInput =
                                props.inputRefs?.vehicle_number?.current;
                              if (nextInput) {
                                nextInput.focus();
                                if (nextInput.setSelectionRange) {
                                  nextInput.setSelectionRange(
                                    0,
                                    nextInput.value?.length || 0,
                                  );
                                }
                              }
                              return;
                            }
                            if (props.handleKeyDown) {
                              props.handleKeyDown(e);
                            }
                          }}
                          ref={props.inputRefs.dispatch_date}
                        />
                      </div>
                    </div>
                  );
                }

                if (isVehicleNumberField) {
                  return (
                    <div
                      className="row m-0 p-0"
                      style={{ height: "3vh" }}
                      key={index}
                    >
                      <div className="col-4 m-0 p-0 text-start">
                        <label>{label}</label>
                      </div>
                      <div className="m-0 p-0" style={{ width: "1%" }}>
                        <label>:</label>
                      </div>
                      <div
                        className="col-7 p-0 m-0 text-start"
                        style={{ position: "relative" }}
                      >
                        <input
                          style={{
                            textAlign: "left",
                            fontSize: 13,
                            fontWeight: "bold",
                            width: "100%",
                          }}
                          type={type}
                          autoComplete="new-password"
                          name="vehicle_number"
                          id="vehicle_number"
                          value={props.data?.vehicle_number || ""}
                          onChange={props.handleChange}
                          onBlur={props.handleBlur}
                          onFocus={props.handleFocus}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              if (props.handleKeyDown) {
                                props.handleKeyDown(e);
                              } else {
                                e.preventDefault();
                                e.stopPropagation();
                                handleModalClose();
                              }
                              return;
                            }
                            if (props.handleKeyDown) {
                              props.handleKeyDown(e);
                            }
                          }}
                          ref={props.inputRefs.vehicle_number}
                        />
                      </div>
                    </div>
                  );
                }

                return (
                  <InputField
                    height="3vh"
                    key={index}
                    lable={label}
                    type={type}
                    name={name}
                    value={props.data[name] || ""}
                    handleChange={props.handleChange}
                    handleBlur={props.handleBlur}
                    handleFocus={props.handleFocus}
                    isRequired={false}
                    handleKeyDown={props.handleKeyDown}
                    colLabel="col-4"
                    colInput="col-7"
                    colonWidth="1%"
                    ref={props.inputRefs[name]}
                  />
                );
              })}
          </div>
        </div>
      </div>
      <div className="tomasterfooter" style={{ background: "red" }}>
        <Footer />
      </div>
    </div>
  );
});

export default DispatchDetails;
